
// let env_url = 'thsjbvh.site'
let env_url = '/'
const pro_url = window.location.hostname
export const securityKey = '1234567891234567';

let ENV_DEV =  env_url // dev
let ENV_PRO = pro_url


let HOST_URL =''
let BASE_URL = ''
let WS_URL = ''
if (process.env.NODE_ENV === "development"){
    HOST_URL = 'http://' + env_url
    BASE_URL = ENV_DEV
    WS_URL = `wss://${env_url}/data/websocket`
}else{
    HOST_URL = 'https://' + pro_url
    BASE_URL =  'https://' + ENV_PRO
    WS_URL = `ws://localhost/data/websocket`
}


export default {
    HOST_URL,
    BASE_URL,
    WS_URL,
    securityKey
}
